module.exports = __webpack_public_path__ + "img/close.ff053276.svg";